(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('avm-order-results', {
            parent: 'admin',
            url: '/reports/avm-order-results?page&sort',
            reloadOnSearch: false,
            data: {
                // Finance reconciles the Gnowise invoice from this screen, so unlike its siblings it is not
                // ADMIN-only. The body viewers inside it still are.
                authorities: ['ROLE_ADMIN', 'ROLE_VC_FINANCIAL_TEAM'],
                pageTitle: 'avmOrderResults.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/avm-order-results/avm-order-results.html',
                    controller: 'AvmOrderResultsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    var sortString = $stateParams.sort || 'createdDate,desc';
                    return {
                        page: PaginationUtil.parsePage($stateParams.page) || 1,
                        sort: sortString,
                        predicate: PaginationUtil.parsePredicate(sortString),
                        ascending: PaginationUtil.parseAscending(sortString)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('avmOrderResults');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
